import React, { useContext } from 'react';
import {
  FilterWrapper,
  Dropdown,
  ButtonGroup,
  FilterButton
} from './FilterRebrand.styled';
import Typography from '@latitude/typography';
import { AnalyticsContext, trackEvent } from 'latitude-analytics';

export function Filter({ options, inactiveColor, location, value, trackingId, onChange, ...rest }) {
  const COMPONENT_ID = 'filter-rebrand';
  const [analytics] = useContext(AnalyticsContext);
  const componentIdentifier = trackingId
    ? `${trackingId}-${COMPONENT_ID}`
    : COMPONENT_ID;
  if (!options?.length) return null;

    const handleChange = (selectedFilter) => {
    onChange(selectedFilter);

    if (analytics) {
      trackEvent(analytics, {
        category: 'tab',
        action: 'interaction',
        label: selectedFilter,
        location,
      });
    }
  };

  return (
    <FilterWrapper className={componentIdentifier}>
      {/* Mobile / Tablet */}
      <Dropdown
        className={`${componentIdentifier}-dropdown`}
        value={value}
        onChange={(e) => handleChange(e.target.value)}
      >
        {options.map(option => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </Dropdown>

      {/* Desktop */}
      <ButtonGroup className={`${componentIdentifier}-cta-wrapper`}>
        {options.map(option => {
          const isActive = option.value === value;
          console.log(option.value, value);

          return (
            <FilterButton
              key={option.value}
              type="button"
              active={isActive}
              inactiveColor={inactiveColor}
              aria-pressed={isActive}
              className={`${componentIdentifier}-cta`}
              onClick={() => handleChange(option.value)}
            >
              <Typography.CTARegular>{option.label}</Typography.CTARegular>
            </FilterButton>
          );
        })}
      </ButtonGroup>
    </FilterWrapper>
  );
}
